import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { BsWhatsapp } from "react-icons/bs";

export default function Contact() {

    const navi = useNavigate();
    return (
        <>
            <title>Contact Hack98 | Wholesale Jeans Enquiry & Support</title>
            <meta name="description" content="Contact Hack98 for wholesale jeans enquiries, bulk denim orders, distributor support, and business partnerships." />
            <meta name="keywords" content="denim contact supplier, jeans enquiry online, wholesale jeans manufacturer India, bulk jeans supplier, denim order support, wholesale jeans supplier, premium denim jeans, men’s jeans wholesale, boys denim wholesale, bulk denim jeans, menswear near me, jeans near me, denims for men, denims for boys near me" />

            <meta property="og:title" content="Contact Hack98 | Wholesale Jeans Enquiry & Support" />
            <meta property="og:site_name" content="Hack98" />
            <meta property="og:url" content="https://hack98.club/" />
            <meta property="og:description" content="Contact Hack98 for wholesale jeans enquiries, bulk denim orders, distributor support, and business partnerships." />
            <meta property="og:image" content="images /logoo.jpeg" />

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="hack98" />
            <meta name="twitter:description" content="Contact Hack98 for wholesale jeans enquiries, bulk denim orders, distributor support, and business partnerships." />
            <meta name="twitter:app:country" content="india" />

            <div className="navbarrrr">
                <Navbar />
            </div>
            <div className="container px-3 my-5">
                <div className="row justify-content-around align-items-start">
                    {/* Map Section */}
                    <div className="col-lg-6 col-md-10 mt-5">
                        <div className="p-2">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14007.351735219654!2d77.12834329797255!3d28.634618994001727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d032314fcd069%3A0x5a3e33a4d4962d71!2sNaraina%20Industrial%20Area%20Phase%201%2C%20Naraina%2C%20New%20Delhi%2C%20Delhi%20110028!5e0!3m2!1sen!2sin!4v1754398636595!5m2!1sen!2sin" width="100%" height="450" className="border-0" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Map - Naraina, Delhi"></iframe>
                        </div>
                    </div>

                    {/* Contact Form Section */}
                    <div className="col-lg-6 col-md-10 mt-5">
                        <section className="p-1">
                            <h1 className="mb-3 h4">Contact Us</h1>
                            <p>
                                Email us at&nbsp;
                                <strong>
                                    <a href="mailto:rinksdenim715@gmail.com" className="text-primary text-decoration-none fw-bold"> rinksdenim715@gmail.com</a>
                                </strong>
                                &nbsp;or call&nbsp;
                                <strong>
                                    <a href="tel:+91-9517909090" className="text-primary text-decoration-none fw-bold">+91-9517909090</a>
                                </strong>
                            </p>
                            <form>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="name" className="form-label">
                                            Full Name
                                        </label>
                                        <input type="text" className="form-control" id="name" placeholder="Your name" required />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="email" className="form-label">
                                            Email address
                                        </label>
                                        <input type="email" className="form-control" id="email" placeholder="Your email" required />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="phone" className="form-label">
                                            Phone Number
                                        </label>
                                        <input type="tel" className="form-control" id="phone" placeholder="Your phone number" required />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="message" className="form-label">
                                        Message
                                    </label>
                                    <textarea className="form-control" id="message" rows="4" placeholder="Write your message..." required></textarea>
                                </div>
                                <button type="submit" className="btn btn-danger">
                                    Submit
                                </button>
                            </form>
                        </section>
                    </div>
                </div>
            </div>

            {/* <!-- FAQs --> */}
            <div className="px-5">
                <section class="mb-3">
                    <h4 class="mb-3 mt-4">Frequently Asked Questions</h4>
                    <div class="accordion" id="faqAccordion">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
                                    Who can place an order on this website?
                                </button>
                            </h2>
                            <div id="faq1" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                                <div class="accordion-body">
                                    This website is only for distributors, retailers, and resellers. We do not sell directly to individual customers.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
                                    What is the minimum order quantity (MOQ)?
                                </button>
                            </h2>
                            <div id="faq2" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                <div class="accordion-body">
                                    Minimum order quantity usually starts at 50 to 100 pieces depending on the product. MOQ details will be mentioned on each product page.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
                                    Are your products made in India?
                                </button>
                            </h2>
                            <div id="faq3" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                                <div class="accordion-body">
                                    Yes, all denim products are proudly designed and manufactured at our in-house facility in India.
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="position-fixed bottom-0 end-0 p-3 z-3">
                    {/* <button
                        className="btn btn-primary fixed-join-btn text-light fw-bold px-4 py-2 shadow rounded-pill me-2"
                        onClick={() => navi("/Distributor")}
                    >
                        + JOIN NOW
                    </button> */}
                    <button
                        className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                        onClick={() =>
                            window.open(
                                "https://wa.me/919517909090?text=Hi%2C%20I%20am%20interested%20in%20your%20products.%20Can%20you%20help%20me%3F",
                                "_blank"
                            )
                        }
                    >
                        <BsWhatsapp size={24} />
                    </button>
                </div>
                <div className="px-1">
                    <h4>Customer Support</h4>
                    <p>
                        <span className="text-dark fw-bold">
                            If you need help with an order or inquiry?
                        </span>
                        <br />
                        Our team is available Mon-Sat | 10:00 AM - 7:00 PM
                        <br />
                        <p>Need help? <br />
                            📞 Call/WhatsApp:<a href="tel:+91-9517909090" className="call-link text-primary text-decoration-none fw-bold">+91-9517909090</a>
                            <br />
                            📧 Email: &nbsp;
                            <a href="mailto:rinksdenim715@gmail.com" className="email-link text-primary text-decoration-none fw-bold">
                                rinksdenim715@gmail.com
                            </a>
                        </p>
                    </p>
                </div>
                <div className="px-1">
                    <h4>Become a Distributor</h4>
                    <p>
                        <span className="text-dark fw-bold">
                            💼 Want to sell Hack98 products?
                        </span>
                        <br />
                        We are looking for retailers and wholesalers to join our distributor network.
                        <br />
                        👉 <Link to={"/Distributor"}>Click</Link> here to apply or mention it in your message above.
                    </p>
                </div>
                {/* <div className="px-1">
                    <h5 className="mb-3">📄 Need the full product catalog with Minimum Order Quantity and specifications?</h5>
                    <a
                        href="/catalogs/latest-catalog.pdf" // Replace with your actual file path
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button className="btn btn-primary">
                            Download Latest Catalog
                        </button>
                    </a>
                </div> */}
            </div>
            <div className="row m-0 mt-4 align-items-center justify-content-center d-flex flex-wrap p-0 bottom-0 w-100">
                <Footer />
            </div>

        </>
    )
}